import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { getPathFromRouteId } from 'core/utils/route-utils'
import { RouteId } from 'core/routing/router/route-ids'
import WidgetLoading from '../../../../components/common/cards/widget-loading'
import StoreTrajectoryRecap from './recap/store-trajectory-recap'
import { VpButton, VpLoader } from '@vtmn-play/react'
import { useContext } from 'react'
import { StoreTrajectoryContext } from '../state/store-trajectory-context'
import useStoreYearlyForecastValues from './use-store-yearly-forecast-values'
import { useApiTakeDirectorTrajectoryPhoto } from 'core/api/trajectory-photo/useApiTakeDirectorTrajectoryPhoto'
import Alert from '../../../../components/common/alert/alert'

const StoreTrajectoryValidate = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { storeId, targetYear } = useContext(StoreTrajectoryContext)
  const { mutate: takeDirectorTrajectoryPhoto, isPending } = useApiTakeDirectorTrajectoryPhoto()

  const goBackToEdit = () => {
    void navigate(getPathFromRouteId(RouteId.StoreTrajectoriesEdit))
  }
  const validate = () => {
    if (storeId == null || targetYear == null) return
    takeDirectorTrajectoryPhoto(
      { storeId, year: targetYear },
      {
        onSuccess: () => {
          void navigate(getPathFromRouteId(RouteId.StoreTrajectoriesConsult))
        }
      }
    )
  }

  const { isLoading, storeTrajectoryConsultValues } = useStoreYearlyForecastValues(storeId, targetYear)

  return (
    <div className="mg-store-trajectory" data-testid="store-trajectory-recap">
      <div className="mg-store-trajectory-header">
        <div className="mg-store-trajectory-header-title vp-title-m" data-testid="store-trajectory-validate-title">
          {t('general.trajectory.store.validate.title', { year: targetYear })}
        </div>
      </div>
      <div className="mg-store-trajectory-body" data-testid="store-trajectory-validate-body">
        {isLoading ? (
          <WidgetLoading
            className="mg-store-trajectory-loading"
            dataTestId="store-trajectory-consult-loading"
            skeletonCount={3}
          />
        ) : (
          <div className="mg-store-trajectory-body-content" data-testid="store-trajectory-validate-content">
            <Alert
              text={t('general.trajectory.store.validate.notice')}
              icon={{ name: 'information', style: 'COLORED' }}
              severity="info"
              closable={false}
            />
            <div className="mg-store-trajectory-body-content-sections" data-testid="store-trajectory-validate-sections">
              <StoreTrajectoryRecap storeTrajectoryConsultValues={storeTrajectoryConsultValues} />{' '}
            </div>
            <div className="mg-store-trajectory-body-content-buttons" data-testid="store-trajectory-validate-buttons">
              <VpButton
                data-testid="store-trajectory-back"
                variant="secondary"
                variantStyle="regular"
                size="medium"
                disabled={isPending}
                onClick={goBackToEdit}
              >
                {t('general.trajectory.store.validate.back')}
              </VpButton>
              <VpButton
                data-testid="store-trajectory-consult-validate"
                variant="primary"
                variantStyle="regular"
                size="medium"
                disabled={isPending || storeId == null || targetYear == null}
                aria-label={isPending ? t('general.trajectory.store.validate.validate') : undefined}
                onClick={validate}
              >
                {isPending ? (
                  <span data-testid="store-trajectory-validate-loader">
                    <VpLoader {...({ variantStyle: 'inverse' } as any)} />
                  </span>
                ) : (
                  t('general.trajectory.store.validate.validate')
                )}
              </VpButton>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default StoreTrajectoryValidate
